module.exports = "<app-prospect-menu></app-prospect-menu>\n<span class=\"clearfix\"></span>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/prospect.component.html
// module id = ./src/app/prospect/prospect.component.html
// module chunks = main